import * as React from "react";
const SvgIconBatteryreact = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 20 20" {...props}><path fill="currentColor" fillRule="evenodd" d="M15 6H3v7h12zM3 4H1v11h16V4H3m15 7.666a2.17 2.17 0 0 0 0-4zM13.5 7.5h-9v4h9z" clipRule="evenodd" style={{
    fill: "currentColor",
    fillOpacity: 1
  }} /></svg>;
export default SvgIconBatteryreact;